
class LinkService {
  getpythonlink() {
    return 'https://api-fda.ci2ict.com'
    // return 'http://localhost:8081';
  }
}

export default new LinkService();

